import { lazy } from 'react';
import { Navigate } from 'react-router';
import Index from '../pages/Admin/Index';
import Home from '../pages/Admin/Home';

const RequestAccountPage = lazy(
  () => import('../pages/Admin/Request/RequestAccountPage')
);

const RequestPage = lazy(
  () => import('../pages/Admin/RequestPage/RequestPage')
);

const ManageRequestAccount = lazy(
  () => import('../pages/Admin/Request/ManageRequsetAccountPage')
);

const ManageRequestPage = lazy(
  () => import('../pages/Admin/RequestPage/ManageRequsetPage')
);

const DashboardAccounts = lazy(
  () => import('../pages/Admin/Dashboard/DashboardAccounts')
);
const DashboardPages = lazy(
  () => import('../pages/Admin/Dashboard/DashboardPages')
);
const DashboardVps = lazy(
  () => import('../pages/Admin/Dashboard/DashboardVps')
);
const DashboardMember = lazy(
  () => import('../pages/Admin/Dashboard/DashboardMember')
);

const Analytics = lazy(() => import('../pages/Admin/Dashboard/Analytics'));
const ManageAccount = lazy(
  () => import('../pages/Admin/Account/ManageAccount')
);
const ManageStock = lazy(() => import('../pages/Admin/Account/ManageStock'));
const UploadAccount = lazy(
  () => import('../pages/Admin/Account/UploadAccount')
);

const DownloadAccount = lazy(
  () => import('../pages/Admin/Account/DownloadAccount')
);

const VpsAlert = lazy(() => import('../pages/Admin/VpsAlert/VpsAlert'));
const MemberPage = lazy(() => import('../pages/Admin/Member/MemberPage'));

const ManageUser = lazy(() => import('../pages/Admin/User/ManageUser'));
const ManagePage = lazy(() => import('../pages/Admin/FacebookPage/ManagePage'));
const ManagePageStock = lazy(
  () => import('../pages/Admin/FacebookPage/ManagePageStock')
);
const UploadPage = lazy(() => import('../pages/Admin/FacebookPage/UploadPage'));
const Login = lazy(() => import('../pages/Auth/Login'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes = (userId: any) => [
  {
    path: '/admin',
    element: userId ? <Index /> : <Navigate to="/" />,
    children: [

      { path: 'home', element: <Home /> },
      { path: 'dashboard-accounts', element: <DashboardAccounts /> },
      { path: 'dashboard-pages', element: <DashboardPages /> },
      { path: 'dashboard-vps', element: <DashboardVps /> },
      { path: 'dashboard-members', element: <DashboardMember /> },
      { path: 'analytics', element: <Navigate to="/admin/sales-analytics" /> },
      { path: 'sales-analytics', element: <Analytics /> },
      { path: 'manage-accounts/:type', element: <ManageAccount /> },
      { path: 'manage-stock/:type', element: <ManageStock /> },
      { path: 'upload-accounts', element: <UploadAccount /> },
      { path: 'download-accounts', element: <DownloadAccount /> },
      { path: 'manage-users', element: <ManageUser /> },
      { path: 'manage-pages', element: <ManagePage /> },
      { path: 'manage-pages-stock', element: <ManagePageStock /> },
      { path: 'upload-pages', element: <UploadPage /> },
      { path: 'vps-alert', element: <VpsAlert /> },
      { path: 'members', element: <MemberPage /> },
      { path: 'request-accounts', element: <RequestAccountPage /> },
      { path: 'manage-requests', element: <ManageRequestAccount /> },
      { path: 'request-pages', element: <RequestPage /> },
      { path: 'manage-requests-pages', element: <ManageRequestPage /> },
      { path: '', element: <Navigate to="/admin/dashboard-accounts" /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/',
    element: !userId ? <Login /> : <Navigate to="admin/dashboard-accounts" />,
    children: [
      { path: '', element: <Navigate to="/login" /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;
